<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">停车场详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="停车场名称" prop="name">
                <el-input v-model="data.name" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="data.code">
              <el-form-item label="停车场编号" prop="code">
                <el-input v-model="data.code" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="总车位数" prop="totalNum">
                <el-input
                  v-model="data.totalNum"
                  :disabled="!IsEdit"
                  @blur="computeUsedPlace"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="剩余车位数" prop="surplusNum">
                <el-input
                  v-model="data.surplusNum"
                  :disabled="!IsEdit"
                  @blur="computeUsedPlace"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="已使用车位数" prop="UsedSpace">
                <el-input v-model="UsedSpace" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="Longitude">
                <el-input
                  v-model="data.Longitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="Latitude">
                <el-input
                  v-model="data.Latitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.Latitude"
              :point_lng="data.Longitude"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
            <!-- <el-button @click="getCurrentPostion()" style="margin-left:1.5rem;">定位</el-button> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="linkPeople">
                <el-input
                  v-model="data.linkPeople"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="linkPhone">
                <el-input
                  v-model="data.linkPhone"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import { getDetail, save } from "@/api/src/entityBaseAllInfo";

export default {
  name: "ScenicCarParkManagerEdit",
  controller: "UI",
  action: "ScenicCarParkManagerEdit",
  data() {
    return {
      data: {
        Latitude: "",
        Longitude: "",
        totalNum: 0,
        surplusNum: 0,
        linkPeople: "",
        linkPhone: "",
        name: "",
      },
      UsedSpace: 0,
      IsEdit: false,
      typeArr: [],
      rules: {
        name: [
          { required: true, message: "请输入停车场名称", trigger: "blur" },
        ],

        Longitude: [
          {
            required: false,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        Latitude: [
          {
            required: false,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        totalNum: [
          {
            required: false,
            message: "请选输入有效的总车位数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
        surplusNum: [
          {
            required: false,
            message: "请选输入有效的剩余车位数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
        UsedSpace: [
          {
            required: false,
            message: "请选输入有效的已用车位数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
      },
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },

  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    onGotLngLat(obj) {
      this.data.Latitude = obj.lat || 0;
      this.data.Longitude = obj.lng || 0;
    },
    computeUsedPlace() {
      this.UsedSpace = this.data.totalNum - this.data.surplusNum;
    },

    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        getDetail({ code: InfoId, type: "parking" }).then((response) => {
          this.data = Object.assign(this.data, response.data);
          this.data.totalNum = this.data.totalNum || 0;
          this.data.surplusNum = this.data.surplusNum || 0;
          //this.data = response.data;
          this.UsedSpace = this.data.totalNum - this.data.surplusNum;
          if (response.data.poi) {
            const pois = response.data.poi.split(",");
            if (pois.length > 1) {
              this.data.Longitude = pois[0];
              this.data.Latitude = pois[1];
            }
          }
        });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      if (this.data.Longitude && this.data.Latitude) {
        this.data.poi = this.data.Longitude + "," + this.data.Latitude;
      }
      this.data.type = "parking";
      this.data.entityTypeCode = "resource";
      this.data.entityTypeName = "资源";
      this.data.typeOneCode = "parking";

      save(this.data).then((response) => {
        if (response.code == 0) {
          this.$message({
            type: "success",
            message: "保存成功！",
          });
          this.onBack();
        }
      });
    },
  },
};
</script>
